import { getSharepointDocuments } from '../../graphql/queries';
import {
  GET_DOCUMENTS_ABORTED,
  GET_DOCUMENTS_REQUESTED,
  GET_DOCUMENTS_COMPLETED,
  GET_DOCUMENTS_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';
import isInGroup from '../../services/util/isInGroup';

const getDocumentsForContactAction = () => async (dispatch, getState) => {
  const { contacts, documents, session } = getState();
  const sessionData = session.get('data');
  const contact = contacts.get('set');
  const documentsData = Object.create(documents.get('data'));

  if (!documentsData.items) {
    documentsData.items = [];
  }

  const ContactID = contact?.ContactID ?? null;
  const AccountID = contact?.AccountID;
  const ProfessionalContactID = null;

  let documentsclients;

  // if you are a client
  if (
    isInGroup(sessionData, 'Client') &&
    (documentsData?.items ?? []).length > 0
  ) {
    // eslint-disable-next-line prefer-destructuring
    documentsclients = documentsData.items[0];
    // if you are Admin or adviser getting client files
  } else if (AccountID) {
    documentsclients = documentsData.items.find(
      (item) => AccountID === item.AccountID,
    );
  }

  if (documentsclients) {
    debug('Running abort - GET_DOCUMENTS_ABORTED');
    dispatch({
      type: GET_DOCUMENTS_ABORTED,
    });

    return;
  }

  dispatch({
    type: GET_DOCUMENTS_REQUESTED,
  });
  try {
    const { data } = await api.graphql({
      query: getSharepointDocuments,
      variables: {
        ContactID,
        ProfessionalContactID,
      },
    });

    if (data?.getSharepointDocuments?.AccountID) {
      documentsData.items.push(data.getSharepointDocuments);

      if (data?.getSharepointDocuments?.ChildAccounts?.length > 0) {
        const childAccountDocuments = await Promise.all(
          data.getSharepointDocuments.ChildAccounts.map(async (ca) => {
            const { data: childAccountData } = await api.graphql({
              query: getSharepointDocuments,
              variables: {
                ContactID,
                ProfessionalContactID,
                AccountID: ca.AccountID,
              },
            });

            return childAccountData?.getSharepointDocuments;
          }),
        );

        const filteredChildAccountDocuments = childAccountDocuments.filter(
          (cad) => !!cad.AccountID,
        );

        documentsData.items.push(...filteredChildAccountDocuments);
      }
    }

    const payload = { items: documentsData.items || [] };

    dispatch({
      type: GET_DOCUMENTS_COMPLETED,
      payload,
    });
  } catch (err) {
    debug(GET_DOCUMENTS_FAILED, err);

    dispatch({
      type: GET_DOCUMENTS_FAILED,
      payload: err,
    });
  }
};

export default getDocumentsForContactAction;
